<template>
  <div class="login">
    <!-- <div class="container h-100 w-50 p-3 align-middle"> -->
    <b-container>
      <b-alert variant="danger" show class="error-banner">Verkeerde gebruikersnaam of wachtwoord</b-alert>
      <b-form @submit="onSubmit" @reset="onReset" class>
        <b-form-group id="input-group-1" label="Email adres:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="form.email"
            type="email"
            required
            placeholder="Email adres"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="Wachtwoord:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.password"
            type="password"
            required
            placeholder="Wachtwoord"
          ></b-form-input>
        </b-form-group>

        <b-button type="submit" variant="primary">Log in</b-button>
        <b-button type="reset" variant="danger">Wissen</b-button>
      </b-form>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      form: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$api
        .post("/user/login", this.form)
        .then(res => {
          if (res.status === 200 && res.data && res.data.token) {
            sessionStorage.setItem("authToken", res.data.token);
            this.$updateAxios();
            this.$router.go(-1);
          }
        })
        .catch(response => {
          document.querySelector(".error-banner").classList.add("visible");

          this.form.email = "";
          this.form.password = "";
        });
    },
    onReset(evt) {
      evt.preventDefault();

      // Reset our form values
      this.form.email = "";
      this.form.password = "";
    }
  }
};
</script>

<style lang="scss" scoped>
div.login {
  background-color: var(--primary-color);
  min-height: 60vh;
}

.error-banner {
  visibility: hidden;
}
</style>>



// WEBPACK FOOTER //
// src/pages/Login.vue